// Generated and maintained by scripts/rename-product.mjs.
export const PRODUCT_NAME = "FuckSpam";
export const CANONICAL_APP_ORIGIN = "https://fuckspam.email";
export const ADMIN_APP_ORIGIN = "https://admin.fuckspam.email";
export const LEGACY_APP_ORIGINS = ["https://spamjam-6nz.pages.dev"] as const;
export const LEGACY_ADMIN_ORIGINS = [] as const;
